module.exports = {
  title: {
    home: 'Home',
    productCenter: 'Product Center',
    applicationVideo: 'Application Video',
    aboutDongju: 'About Dongju',
    contactUs: 'Contact Us',
    downloadCenter: 'Download Center',
    cpzl: 'Product information',
    rjxz: 'Software Download',
    rjxz2: 'Download',
    qtwj: 'Other files',
    login: 'Login',
    register: 'Regist',
    search: 'search',
    more: 'more',
    online: 'consultation',
    dqkj: 'Dongqi Technology',
    factory: 'factory',
    equipment: 'equipment',
    team: 'team',
    userCenter: 'Personal',
    kfzx: 'customer service',
    zx: 'consultant',
    wxkf: 'Wechat online',
    gsjj: 'Company Profile',
    zycp: 'Main Products',
    gsry: 'Company Honor',
    c_name: 'SICHUAN DONGJU AUTOMATION TECHNOLOGY CO., LTD',
    product: 'Product Download',
    video: 'video',
    download: 'download',
    engineer: 'engineer',
    purchase: 'purchase',
    CompanyName: 'Company Name',
    address: 'address',
    contacts: 'contacts',
    phone: 'phone',
    email: 'e-mail',
    nikename: 'nikename',
    pwd: 'password',
    yyzh: 'Do you have an account',
    ljdl: 'Log in now',
    total: 'total',
    pages: 'pages',
    qg: 'National operators',
    ljcg: 'Buy now',
    cpcs: 'Product parameters',
    model: 'model',
    trip: 'trip',
    dzjd: 'Action angle',
    style: 'Style',
    show: 'Show all',
    put: 'Put it away',
    yyly: 'Application area',
    price: 'price',
    cgsl: 'number',
    xj: 'total',
    addcars: 'add to cart',
    cpjs: 'Product',
    wexz: 'Download',
    submit: 'Submit',
    xxcs: 'specification',
    cpxl: 'Product Series',
    xhsm: 'Model Description',
    shumo: '3d digital model',
    zlxz: 'Download',
    fj: 'annex',
    jj: 'Introduction',
    bbh: 'version number',
    fbsj: 'Publishing time',
    wjxz: 'file download',
    wjsm: 'File Description',
    kp: 'Billing information'
  },
  content: {
    index_about_info: 'Sichuan Dongju Automation Technology Co., Ltd. is located in Hi-Tech Industrial Park of Ziyang, Sichuan Province. Founded in 2014, the company has over 20-year experience in R&D and manufacturing of servo motor modules. It is a comprehensive enterprise integrating R&D, production, sales and modern-service support.\n' +
      'Equipped with 33 CNC machine tools, more than 90 sets of various mechanical processing equipment and over 10 sets of special gripper production facilities and test platforms. 58% of our employees hold college degree or above, enabling us with strong R&D and manufacturing capabilities.',
    index_down: 'Download',
    about_info_2: "Focusing on factory automation, we promote the standardization and modularization of hardware and software, and deliver one-stop systematic solutions. Our solutions reduce industry reliance on talent, technology and equipment, help clients cut R&D costs and improve equipment reliability. Our key products include electric grippers, rotary platforms, miniature linear slides, high-performance linear slides, coordinate manipulators and industrial robots.",
    about_info_3: 'The company has been rated as "advanced enterprise of scientific and technological innovation" in 2016. All products on the shelves are independently developed and produced, with completely independent intellectual property rights. The products are widely used in manufacturing, scientific research, military industry and other fields.'
  },
  tips: {
    r1: 'Please input your company name!',
    r2: 'Please input your address!',
    r3: 'Please input your contacts!',
    r4: 'Please input your phone number!',
    r5: 'Please input your E-mail!',
    r6: 'Please input your nickname!',
    r7: 'Please input your password!',
    r8: 'Please input right E-mail!',
    l1: 'The user name cannot be empty!',
    l2: 'Password cannot be empty!',
    a1: 'please input your detailed address',
    a2: 'please input your consignee',
    a3: 'Are you sure?',
    a4: 'Please select shipping address',
    o1: 'Note: please send the transfer record to the email address after successful payment',
    s1: 'please input the enterprise name',
    s2: 'please input the taxpayer identification number',
    s3: 'please input the enterprise address',
    s4: 'please input the Bank of deposit',
    s5: 'please input bank account number'
  },
  member: {
    gwc: 'Shopping Cart',
    cgdd: 'Purchase order',
    shdz: 'Receiving address',
    tcdl: 'Log out',
    shr: 'consignee',
    lxdh: 'contact number',
    edit: 'edit',
    confirm: 'YES',
    cancel: 'NO',
    del: 'delete',
    dgzhdk: 'Withdrawal from corporate account',
    skrhm: "payee's account name",
    yhkh: 'bank card number',
    khhh: 'account bank number',
    khyh: 'deposit bank',
    all: 'Check all',
    orderNum: 'Order number',
    qrsh: 'Confirm receipt',
    js: 'Settlement',
    yl: 'preview',
    cpname: 'Product name',
    allshop: 'All Commodities',
    ys: 'selected',
    shop: 'merchandise',
    qymc: 'enterprise name',
    ns: 'taxpayer identification number',
    qydz: 'business address',
    tjdz: 'add address',
    piece: 'piece',
    yfje: 'Amount due',
    y: 'Yuan',
    skf: 'Payee',
    xyb: 'next step',
    yzf: 'Paid'
  }
}
